<template lang="pug">
	modal
		.card.text-left
			.card-header.bg-info
				span.fa.fa-copy.mr-2
				| Copiar inserciones
				button.close(@click="cerrar") &times;
			.card-body
				b Ficheros
				.row.mt-2
					.col
						.input-group.input-group-sm.mb-2
							.input-group-prepend
								.input-group-text Origen
							select.form-control.form-control-sm(v-model="filtro.Origen")
								option(v-for="fichero in listadoFicheros", :key="fichero.FicheroID", :value="fichero.FicheroID") {{fichero.FicheroID}} - {{fichero.Descripcion}}
						b Fechas
						.input-group.input-group-sm
							.input-group-prepend
								.input-group-text Desde
							datepicker(
								v-model="filtro.FechaInicio"
								:monday-first="true"
								input-class="form-control form-control-sm"
							)
							.input-group-prepend.input-group-append
								.input-group-text Hasta
							datepicker(
								v-model="filtro.FechaFin"
								:monday-first="true"
								input-class="form-control form-control-sm"
							)
					.col
						.input-group.input-group-sm
							.input-group-prepend
								.input-group-text Destinos
							select.form-control.form-control-sm(v-model="filtro.Destinos", :multiple="true", @change="cambiaDestinos($event)")
								option(v-for="fichero in listadoFicheros", :key="fichero.FicheroID", :value="fichero.FicheroID") {{fichero.FicheroID}} - {{fichero.Descripcion}}
							.input-group-append
								button.btn.btn-primary(@click="agregarDestino")
									span.fa.fa-plus
				
				.row.mt-2
					.col
						b Acción
						br
						.btn-group
							button.btn.btn-sm(:class="filtro.Accion === 'copiar' ? 'btn-primary' : ''", @click="filtro.Accion = 'copiar'") Copiar
							button.btn.btn-sm(:class="filtro.Accion === 'mover' ? 'btn-primary' : ''", @click="filtro.Accion = 'mover'") Mover
					.col(v-if="filtro.Destinos.length > 1")
						b Define los porcentajes de reparto (deben sumar 100)
						.row.mt-2(v-for="destino in filtro.DestinosAsignados", :key="destino.FicheroID")
							.col
								.input-group.input-group-sm
									.input-group-prepend
										.input-group-text
											div(style="font-size:0.9em;max-width:170px;text-overflow:ellipsis;white-space:nowrap;overflow: hidden;") {{ destino.FicheroID }} - {{nombreFichero(destino.FicheroID)}}
									input.form-control.form-control-sm(style="text-align:right;" size="2", v-model.number="destino.Porcentaje")
									.input-group-append
										.input-group-text %
			.card-body.bg-light
				b Personalizar importes
				div.mt-2
					label
						input.mr-2(type="checkbox", id="modificarImportes", v-model="filtro.ModificarImportes")
						label Personalizar importes
				.row(v-if="filtro.ModificarImportes")
					.col.p-1
						.form-group
							label Precio
							input.form-control.form-control-sm(v-model.number="filtro.Importe", @keyup="calculaImporte")
					.col.p-1
						.form-group
							label Descuento
							input.form-control.form-control-sm(v-model.number="filtro.Descuento", @keyup="calculaImporte")
					.col.p-1
						.form-group
							label Recargo
							input.form-control.form-control-sm(v-model.number="filtro.Recargo", @keyup="calculaImporte")
					.col.p-1
						.form-group
							label Final
							input.form-control.form-control-sm(disabled="true", :value="filtro.ImporteFinal")
			.card-footer
				button.btn.btn-sm.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
		ModalOriginal(:ClienteID="contrato.ClienteID", v-if="nuevoDestino", @seleccionar="setNuevoDestino($event)", @cerrar="nuevoDestino = null")
							
</template>


<script>
import ModalOriginal from '../utilidades/modalSeleccionOriginal.component.vue'
export default {
	props: ['contrato', 'linea'],
	components: {
		ModalOriginal
	},
	data () {
		return {
			filtro: {
				Origen: null,
				Destinos: [],
				DestinosAsignados: [],
				FechaInicio: null,
				FechaFin: null,
				Accion: 'copiar',
				ModificarImportes: false,
				Importe: null,
				Descuento: null,
				Recargo: null,
				ImporteFinal: null
			},
			nuevosDestinos: [],
			nuevoDestino: null,
			inserciones: []
		}
	},
	created () {
		this.inserciones = JSON.parse(JSON.stringify(this.linea.inserciones))
	},
	computed: {
		listadoFicheros () {
			let mapa = this.inserciones.reduce((acc, ins) => {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion
					})
				}
				return acc
			}, new Map())

			mapa = this.nuevosDestinos.reduce((acc, ins) => {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion
					})
				}
				return acc
			}, mapa)

			return Array.from(mapa).map(d => d[1])
		},
		importeFinal () {
			return 0
		}
	},
	methods: {
		agregarDestino () {
			this.nuevoDestino = true
		},
		setNuevoDestino (ficheros) {
			this.nuevosDestinos = this.nuevosDestinos.concat(ficheros)
		},
		nombreFichero (FicheroID) {
			return this.listadoFicheros.reduce((acc, fichero) => {
				if (fichero.FicheroID === FicheroID) {
					acc = fichero.Descripcion
				}
				return acc
			}, '')
		},
		calculaImporte () {
			let importe = 0
			if (this.filtro.ModificarImportes) {
				importe = typeof this.filtro.Importe === 'number' ? this.filtro.Importe : 0
				const descuento = typeof this.filtro.Descuento === 'number' ? this.filtro.Descuento : 0
				const recargo = typeof this.filtro.Recargo === 'number' ? this.filtro.Recargo : 0

				importe = importe - (importe * descuento / 100) + recargo
				importe = this.$options.filters.round(importe, 2)
			}

			this.filtro.ImporteFinal = importe
		},
		cambiaDestinos (ev) {
			// Quitamos los destinos no seleccionados
			this.filtro.DestinosAsignados = this.filtro.DestinosAsignados.filter(d => (this.filtro.Destinos.indexOf(d.FicheroID) >= 0))

			// Agregamos los que no tenemos
			this.filtro.Destinos.forEach(d => {
				let presente = false
				this.filtro.DestinosAsignados.forEach((a, i) => {
					if (a.FicheroID === d) {
						presente = true
					}
				})

				if (!presente) {
					this.filtro.DestinosAsignados.push({
						FicheroID: d,
						Porcentaje: 0,
						Descripcion: this.nombreFichero(d)
					})
				}
			})
		},
		guardar () {
			if (!this.filtro.Origen) {
				this.$error('Error', 'Debes seleccionar el fichero de origen')
				return
			}

			if (!this.filtro.Destinos.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un destino')
				return
			}

			if (this.filtro.DestinosAsignados.length === 1) {
				this.filtro.DestinosAsignados = this.filtro.DestinosAsignados.map(d => {
					d.Porcentaje = 100
					return d
				})
			}

			const porcentajeTotal = this.filtro.DestinosAsignados.reduce((acc, fichero) => {
				acc = acc + fichero.Porcentaje
				return acc
			}, 0)

			if (porcentajeTotal !== 100) {
				this.$error('Error', 'Los porcentajes deben sumar 100')
				return
			}

			if (!this.filtro.FechaInicio) {
				this.$error('Error', 'Debes seleccionar la fecha de inicio')
				return
			}

			if (!this.filtro.FechaFin) {
				this.$error('Error', 'Debes seleccionar la fecha de fin')
				return
			}

			this.filtro.FechaInicio.setHours(0)
			this.filtro.FechaInicio.setMinutes(0)
			this.filtro.FechaInicio.setSeconds(0)
			this.filtro.FechaInicio.setMilliseconds(0)

			this.filtro.FechaFin.setHours(23)
			this.filtro.FechaFin.setMinutes(59)
			this.filtro.FechaFin.setSeconds(59)
			this.filtro.FechaFin.setMilliseconds(999)

			if (this.filtro.FechaInicio > this.filtro.FechaFin) {
				this.$error('Error', 'La fecha de inicio debe ser anterior o igual a la de fin')
			}

			this.repartir()
		},

		repartir () {
			// Lo primero es analizar cuantas inserciones tiene origen
			const totalInserciones = this.inserciones.reduce((acc, ins) => {
				if (ins.FicheroID === this.filtro.Origen) {
					acc = acc + ins.Inserciones
				}
				return acc
			}, 0)

			// Ahora calculamos las que corresponden a cada destino
			const destinos = this.filtro.DestinosAsignados.map(d => {
				d.Inserciones = Math.floor(d.Porcentaje * totalInserciones / 100)
				return d
			})

			// Si sobrara alguna inserción se la asignamos al que tenga mayor porcentaje
			const asignadas = destinos.reduce((acc, dst) => {
				acc = acc + dst.Inserciones
				return acc
			}, 0)

			if (asignadas !== totalInserciones) {
				destinos.sort((a, b) => {
					if (a.Porcentaje > b.Porcentaje) {
						return 1
					} else if (a.Porcentaje < b.Porcentaje) {
						return -1
					} else {
						return 0
					}
				})

				destinos[0].Inserciones = destinos[0].Inserciones + totalInserciones - asignadas
			}

			// Construimos un contador para restart inserciones a los destinos
			const pendientes = Array.from(destinos.reduce((acc, dst) => {
				acc.set(dst.FicheroID, dst)
				return acc
			}, new Map())).map(d => d[1])
			// Ahora recorremos las inserciones de la línea para sustituir las que correspondan en fecha y origen
			let indicePendientes = 0
			for (let i = this.inserciones.length - 1; i >= 0; i--) {
				const ins = this.inserciones[i]
				const insID = this.filtro.Accion + '-' + ins.InsercionID
				const insercionesInsercion = ins.Inserciones + 0
				let destinoAnterior = null
				if (ins.DiaUnix < this.filtro.FechaInicio.getTime() || ins.DiaUnix > this.filtro.FechaFin.getTime()) {
					continue
				}
				for (let a = 0; a < insercionesInsercion; a++) {
					if (ins.FicheroID === this.filtro.Origen) {
						let iP = null
						let destino = null
						let bucle = 0
						while (iP === null && bucle < 1000) {
							bucle++
							iP = indicePendientes > pendientes.length - 1 ? indicePendientes % pendientes.length : indicePendientes
							console.log(iP)
							if (pendientes[iP].Inserciones === 0) {
								iP = null
								indicePendientes++
							} else {
								destino = pendientes[iP]

								if (destino.FicheroID === destinoAnterior) {
									destinoAnterior = null
									iP = null
									indicePendientes++
								}
							}
						}

						if (destino === null) {
							this.$error('Error', 'Error repartiendo')
							return
						}

						destinoAnterior = destino.FicheroID

						const nueva = JSON.parse(JSON.stringify(this.inserciones[i]))
						nueva.InsercionID = insID

						const existente = this.inserciones.reduce((acc, ins, i) => {
							if (ins.InsercionID === insID && ins.FicheroID === destino.FicheroID) {
								ins.Indice = i
								acc.push(ins)
							}
							return acc
						}, [])

						if (existente.length > 0) {
							this.inserciones[existente[0].Indice].Inserciones = this.inserciones[existente[0].Indice].Inserciones + 1
						} else {
							nueva.FicheroID = destino.FicheroID
							nueva.Descripcion = destino.Descripcion
							nueva.Inserciones = 1
							this.inserciones.push(nueva)
						}
						if (this.filtro.Accion === 'mover') {
							ins.Inserciones = ins.Inserciones - 1

							if (ins.Inserciones <= 0) {
								this.inserciones.splice(i, 1)
							}
						}

						pendientes[iP].Inserciones = pendientes[iP].Inserciones - 1
					}
				}
			}
			// AHora asignamos nuevos IDs a todas las inserciones
			this.inserciones = this.inserciones.map(i => {
				i.InsercionID = 'I-' + new Date().getTime() + Math.round(Math.random() * 100000)
				return i
			})
			this.$emit('guardar', this.inserciones)
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/copiar-inserciones/copiar-inserciones.vue